import { render, staticRenderFns } from "./PrescriptionsTab.vue?vue&type=template&id=5dd6f416&scoped=true"
import script from "./PrescriptionsTab.vue?vue&type=script&lang=js"
export * from "./PrescriptionsTab.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionsTab.vue?vue&type=style&index=0&id=5dd6f416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd6f416",
  null
  
)

export default component.exports